import styles from './index.module.scss';

const Hero = ({ children, className }) => {
  return (
    <section
      className={`${styles.root} ${className}`}
      data-qa-tag="hero-section"
    >
      {children}
    </section>
  );
};

export default Hero;
